<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'UnitStatus' }" tag="li" class="breadcrumb-item">
						<a href="#">{{ $t('UnitStatus') }}</a>
					</router-link>
				</ol>
			</nav>
			<div class="item-box">
				<div class="row">
					<div class="col-lg-12 col-md-12 col-12">
						<div class="row mb-3">
							<div class="col">
								<h3 class="item-title">
									<div v-if="this.diffMode">
										{{ $t('UnitStatus') }}
									</div>
									<div v-else>
										{{ $t('UnitStatusDiff') }}
									</div>
								</h3>
							</div>
							<div class="col d-flex justify-content-end">
								<button class="pcbtn" :class="!this.diffMode ? 'active' : ''" @click="changeMode()">{{
									$t('DiffMode') }}</button>
								<button class="pcbtn mx-3" :class="this.diffMode ? 'active' : ''" @click="changeMode()">{{
									$t('StatusMode') }}</button>
								<button @click="activeRankBonus" class="pcbtn" :class="this.RankBonus ? 'active' : ''">Rank
									Bonus</button>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="form-group row">
									<label class="col-form-label col-sm-1">{{ $t('Level') }}</label>
									<div class="col-sm-11">
										<input class="form-control mb-3" type="number" name="" v-model="level" value="112">
									</div>
								</div>
							</div>
						</div>
						<div class="row" v-if="this.diffMode">
							<div class="col-12">
								<div class="form-group row">
									<label class="col-form-label col-sm-1">RANK</label>
									<div class="col-sm-11">
										<select class="form-control mb-3" v-model="rank">
											<option value="33">33</option>
											<option value="32">32</option>
											<option value="31">31</option>
											<option value="30">30</option>
											<option value="29">29</option>
											<option value="28">28</option>
											<option value="27">27</option>
											<option value="26">26</option>
											<option value="25">25</option>
											<option value="24">24</option>
											<option value="23">23</option>
											<option value="22">22</option>
											<option value="21">21</option>
											<option value="20">20</option>
											<option value="19">19</option>
											<option value="18">18</option>
											<option value="17">17</option>
											<option value="16">16</option>
											<option value="15">15</option>
											<option value="14">14</option>
											<option value="13">13</option>
											<option value="12">12</option>
											<option value="11">11</option>
											<option value="10">10</option>
											<option value="9">9</option>
											<option value="8">8</option>
											<option value="7">7</option>
											<option value="6">6</option>
											<option value="5">5</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-form-label col-sm-1">{{ $t('Wear') }}</label>
									<div class="col-sm-11">
										<select class="form-control mb-3" v-model="wear">
											<option value="6">6</option>
											<option value="0">0</option>
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div class="row" v-else>
							<div class="col-6">
								<div class="form-group row">
									<label class="col-form-label col-sm-2">L-RANK</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="rank">
											<option value="33">33</option>
											<option value="32">32</option>
											<option value="31">31</option>
											<option value="30">30</option>
											<option value="29">29</option>
											<option value="28">28</option>
											<option value="27">27</option>
											<option value="26">26</option>
											<option value="25">25</option>
											<option value="24">24</option>
											<option value="23">23</option>
											<option value="22">22</option>
											<option value="21">21</option>
											<option value="20">20</option>
											<option value="19">19</option>
											<option value="18">18</option>
											<option value="17">17</option>
											<option value="16">16</option>
											<option value="15">15</option>
											<option value="14">14</option>
											<option value="13">13</option>
											<option value="12">12</option>
											<option value="11">11</option>
											<option value="10">10</option>
											<option value="9">9</option>
											<option value="8">8</option>
											<option value="7">7</option>
											<option value="6">6</option>
											<option value="5">5</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-form-label col-sm-2">L-{{ $t('Wear') }}</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="wear">
											<option value="6">6</option>
											<option value="0">0</option>
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-form-label col-sm-2">{{ $t('StarRank') }}</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="star">
											<option value="0">0</option>
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
											<option value="6">6</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-6">
								<div class="form-group row">
									<label class="col-form-label col-sm-2">R-RANK</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="rankOther">
											<option value="33">33</option>
											<option value="32">32</option>
											<option value="31">31</option>
											<option value="30">30</option>
											<option value="29">29</option>
											<option value="28">28</option>
											<option value="27">27</option>
											<option value="26">26</option>
											<option value="25">25</option>
											<option value="24">24</option>
											<option value="23">23</option>
											<option value="22">22</option>
											<option value="21">21</option>
											<option value="20">20</option>
											<option value="19">19</option>
											<option value="18">18</option>
											<option value="17">17</option>
											<option value="16">16</option>
											<option value="15">15</option>
											<option value="14">14</option>
											<option value="13">13</option>
											<option value="12">12</option>
											<option value="11">11</option>
											<option value="10">10</option>
											<option value="9">9</option>
											<option value="8">8</option>
											<option value="7">7</option>
											<option value="6">6</option>
											<option value="5">5</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-form-label col-sm-2">R-{{ $t('Wear') }}</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="wearOther">
											<option value="6">6</option>
											<option value="0">0</option>
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label class="col-form-label col-sm-2">{{ $t('StarRank') }}</label>
									<div class="col-sm-10">
										<select class="form-control mb-3" v-model="starOther">
											<option value="0">0</option>
											<option value="3">3</option>
											<option value="4">4</option>
											<option value="5">5</option>
											<option value="6">6</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<p>註: 裝備強化MAX、星等5、羈絆滿、正負差1 All Status Max</p>
						<p><a target="_blank" href="https://priconne-redive.jp/news/information/13292/">Rank Bonus</a>
							開啟為7/12後的數值，關閉為7/12前。 若無改變表示無資料</p>
						<button v-if="!fullScreenMode" class="pcbtn" @click="fullScreen()">{{ $t('FullScreen') }}</button>
						<div id="table-wrap" :style="this.clientWidth > 1440 ? '' : 'overflow-x: auto'">
							<button v-if="fullScreenMode" class="pcbtn" @click="fullScreen()">{{ $t('Minify') }}</button>
							<table id="diffTable" class="table table-bordered table-hover" width="100%">
								<thead>
									<tr>
										<th></th>
										<th>{{ $t('Name') }}</th>
										<th>HP</th>
										<th>{{ $t('atk') }}</th>
										<th>{{ $t('magic_str') }}</th>
										<th>{{ $t('def') }}</th>
										<th>{{ $t('magic_def') }}</th>
										<th>{{ $t('physical_critical') }}</th>
										<th>{{ $t('magic_critical') }}</th>
										<th>{{ $t('accuracy') }}</th>
										<th>{{ $t('dodge') }}</th>
										<th>{{ $t('life_steal') }}</th>
										<th>{{ $t('energy_reduce_rate') }}</th>
										<th>{{ $t('energy_recovery_rate') }}</th>
										<th>{{ $t('wave_energy_recovery') }}</th>
										<th>{{ $t('wave_hp_recovery') }}</th>
										<th>{{ $t('hp_recovery_rate') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in diffList">
										<td>
											{{ index + 1 }}. 
											<img width="50"
												:src="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
												alt="">
										</td>
										<td v-html="replaceName(item)"></td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.hp)">
											{{ item.unit_status.hp }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.atk)">
											{{ item.unit_status.atk }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.magic_str)">
											{{ item.unit_status.magic_str }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.def)">
											{{ item.unit_status.def }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.magic_def)">
											{{ item.unit_status.magic_def }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.physical_critical)">
											{{ item.unit_status.physical_critical }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.magic_critical)">
											{{ item.unit_status.magic_critical }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.accuracy)">
											{{ item.unit_status.accuracy }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.dodge)">
											{{ item.unit_status.dodge }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.life_steal)">
											{{ item.unit_status.life_steal }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.energy_reduce_rate)">
											{{ item.unit_status.energy_reduce_rate }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.energy_recovery_rate)">
											{{ item.unit_status.energy_recovery_rate }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.wave_energy_recovery)">
											{{ item.unit_status.wave_energy_recovery }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.wave_hp_recovery)">
											{{ item.unit_status.wave_hp_recovery }}
										</td>
										<td :class="isGreaterOrLowerZeroClass(item.unit_status.hp_recovery_rate)">
											{{ item.unit_status.hp_recovery_rate }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import dt from 'datatables';
import 'datatables.net-fixedcolumns';
import 'datatables/media/css/jquery.dataTables.min.css';
import chara_story_status from '../assets/edata/chara_story_status.txt';
import TwStatus from "../assets/edata/unit_promotion_status.json";
import TwStory from "../assets/edata/chara_story_status.json";
export default {
	name: 'UnitStatus',
	props: ['clientWidth'],
	data() {
		return {
			level: 299,
			rank: "31",
			wear: "6",
			star: "5",
			rankOther: "30",
			wearOther: "6",
			starOther: "5",
			nowUnitList: [],
			diffMode: false,
			fullScreenMode: false,
			RankBonus: true
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '角色數值列表',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: "超異域公主連結☆Re:Dive 的地圖資訊與掉落機率" }
		]
	},
	created: function () {
		this.getUnitStory();
	},
	computed: {
		leftList: function () {
			var self = this;
			var rank = self.rank.toString();
			var wear = self.wear;
			var star = self.star;
			var growth = Number(this.level) + Number(rank);
			var list = _.cloneDeep(self.nowUnitList);
			var leftList = _.forEach(list, function (o) {
				var ps = _.find(self.$store.getters.getUnitPromotionStatus, { "unit_id": o.unit_id, "promotion_level": rank });
				if (!self.RankBonus) {
					var twStatus = _.find(TwStatus, { "unit_id": o.unit_id, "promotion_level": rank });
					if (twStatus) {
						ps = twStatus;
					}
				}
				var ur = _.find(self.$store.getters.getUnitRarity, { "unit_id": o.unit_id, "rarity": star });
				if (!ur) {
					var ur = _.find(self.$store.getters.getUnitRarity, { "unit_id": o.unit_id, "rarity": "5" });
				}

				var up = _.find(self.$store.getters.getUnitPromotion, { "unit_id": o.unit_id, "promotion_level": rank });
				if (!up || !ur || !ps) {
					return;
				}
				var equipmentList = new Array;
				switch (wear) {
					case "0":
						up = {}
						break;
					case "3":
						up = {
							"equip_slot_2": up.equip_slot_2,
							"equip_slot_4": up.equip_slot_4,
							"equip_slot_6": up.equip_slot_6,
						}
						break;
					case "4":
						up = {
							"equip_slot_2": up.equip_slot_2,
							"equip_slot_4": up.equip_slot_4,
							"equip_slot_5": up.equip_slot_5,
							"equip_slot_6": up.equip_slot_6
						}
						break;
					case "5":
						up = {
							"equip_slot_2": up.equip_slot_2,
							"equip_slot_3": up.equip_slot_3,
							"equip_slot_4": up.equip_slot_4,
							"equip_slot_5": up.equip_slot_5,
							"equip_slot_6": up.equip_slot_6
						}
						break;
					default:
						up = {
							"equip_slot_1": up.equip_slot_1,
							"equip_slot_2": up.equip_slot_2,
							"equip_slot_3": up.equip_slot_3,
							"equip_slot_4": up.equip_slot_4,
							"equip_slot_5": up.equip_slot_5,
							"equip_slot_6": up.equip_slot_6
						}
						break;
				}
				_.forEach(up, function (u) {
					var ed = _.find(self.$store.getters.getEquipmentData, { "equipment_id": u })
					if (!ed) {
						return;
					}
					var cloneEq = _.cloneDeep(ed);
					if (!self.RankBonus) {
						switch (u) {
							case "104102":
								cloneEq.energy_recovery_rate = "12.0";
								break;
							case "104013":
								cloneEq.energy_recovery_rate = "5.0";
								break;
							case "104042":
								cloneEq.energy_recovery_rate = "10.0";
								break;
							case "104132":
								cloneEq.energy_recovery_rate = "5.0";
								break;
							case "104371":
								cloneEq.energy_recovery_rate = "5.0";
								break;
							case "104581":
								cloneEq.hp = "240.0"
								cloneEq.energy_recovery_rate = "0.0";
								cloneEq.hp_recovery_rate = "200.0"
								break;
							case "104611":
								cloneEq.hp = "100.0";
								cloneEq.magic_str = "60.0";
								cloneEq.energy_reduce_rate = "25.0";
								cloneEq.energy_recovery_rate = "0.0";
								break;
						}
					}
					equipmentList.push(cloneEq);
				})

				_.forEach(equipmentList, function (u) {
					o.unit_status.accuracy += Number(u.accuracy) * 2;
					o.unit_status.atk += Number(u.atk) * 2;
					o.unit_status.def += Number(u.def) * 2;
					o.unit_status.dodge += Number(u.dodge) * 2;
					o.unit_status.energy_recovery_rate += Number(u.energy_recovery_rate) * 2;
					o.unit_status.energy_reduce_rate += Number(u.energy_reduce_rate) * 2;
					o.unit_status.hp += Number(u.hp) * 2;
					o.unit_status.hp_recovery_rate += Number(u.hp_recovery_rate) * 2;
					o.unit_status.life_steal += Number(u.life_steal) * 2;
					o.unit_status.magic_critical += Number(u.magic_critical) * 2;
					o.unit_status.magic_def += Number(u.magic_def) * 2;
					o.unit_status.magic_penetrate += Number(u.magic_penetrate) * 2;
					o.unit_status.magic_str += Number(u.magic_str) * 2;
					o.unit_status.physical_critical += Number(u.physical_critical) * 2;
					o.unit_status.physical_penetrate += Number(u.physical_penetrate) * 2;
					o.unit_status.wave_energy_recovery += Number(u.wave_energy_recovery) * 2;
					o.unit_status.wave_hp_recovery += Number(u.wave_hp_recovery) * 2;
				})

				o.unit_status.accuracy = self.ToCeil(o.unit_status.accuracy + Number(ps.accuracy) + Number(ur.accuracy) + (Number(ur.accuracy_growth) * growth));
				o.unit_status.atk = self.ToCeil(o.unit_status.atk + Number(ps.atk) + Number(ur.atk) + (Number(ur.atk_growth) * growth));
				o.unit_status.def = self.ToCeil(o.unit_status.def + Number(ps.def) + Number(ur.def) + (Number(ur.def_growth) * growth));
				o.unit_status.dodge = self.ToCeil(o.unit_status.dodge + Number(ps.dodge) + Number(ur.dodge) + (Number(ur.dodge_growth) * growth));
				o.unit_status.energy_recovery_rate = self.ToCeil(o.unit_status.energy_recovery_rate + Number(ps.energy_recovery_rate) + Number(ur.energy_recovery_rate) + (Number(ur.energy_recovery_rate_growth) * growth));
				o.unit_status.energy_reduce_rate = self.ToCeil(o.unit_status.energy_reduce_rate + Number(ps.energy_reduce_rate) + Number(ur.energy_reduce_rate) + (Number(ur.energy_reduce_rate_growth) * growth));
				o.unit_status.hp = self.ToCeil(o.unit_status.hp + Number(ps.hp) + Number(ur.hp) + (Number(ur.hp_growth) * growth));
				o.unit_status.hp_recovery_rate = self.ToCeil(o.unit_status.hp_recovery_rate + Number(ps.hp_recovery_rate) + Number(ur.hp_recovery_rate) + (Number(ur.hp_recovery_rate_growth) * growth));
				o.unit_status.life_steal = self.ToCeil(o.unit_status.life_steal + Number(ps.life_steal) + Number(ur.life_steal) + (Number(ur.life_steal_growth) * growth));
				o.unit_status.magic_critical = self.ToCeil(o.unit_status.magic_critical + Number(ps.magic_critical) + Number(ur.magic_critical) + (Number(ur.magic_critical_growth) * growth));
				o.unit_status.magic_def = self.ToCeil(o.unit_status.magic_def + Number(ps.magic_def) + Number(ur.magic_def) + (Number(ur.magic_def_growth) * growth));
				o.unit_status.magic_penetrate = self.ToCeil(o.unit_status.magic_penetrate + Number(ps.magic_penetrate) + Number(ur.magic_penetrate) + (Number(ur.magic_penetrate_growth) * growth));
				o.unit_status.magic_str = self.ToCeil(o.unit_status.magic_str + Number(ps.magic_str) + Number(ur.magic_str) + (Number(ur.magic_str_growth) * growth));
				o.unit_status.physical_critical = self.ToCeil(o.unit_status.physical_critical + Number(ps.physical_critical) + Number(ur.physical_critical) + (Number(ur.physical_critical_growth) * growth));
				o.unit_status.physical_penetrate = self.ToCeil(o.unit_status.physical_penetrate + Number(ps.physical_penetrate) + Number(ur.physical_penetrate) + (Number(ur.physical_penetrate_growth) * growth));
				o.unit_status.wave_energy_recovery = self.ToCeil(o.unit_status.wave_energy_recovery + Number(ps.wave_energy_recovery) + Number(ur.wave_energy_recovery) + (Number(ur.wave_energy_recovery_growth) * growth));
				o.unit_status.wave_hp_recovery = self.ToCeil(o.unit_status.wave_hp_recovery + Number(ps.wave_hp_recovery) + Number(ur.wave_hp_recovery) + (Number(ur.wave_hp_recovery_growth) * growth));

				if (self.RankBonus) {
					if (Number(self.rank) > 20) {
						if (Number(o.unit_status.atk) > Number(o.unit_status.magic_str)) {
							if (o.unit_id == '109501') {
								console.log(Number(o.unit_status.atk), Number(o.unit_status.magic_str));
							}

							o.unit_status.atk = Number(o.unit_status.atk) + 1800;
						} else {
							o.unit_status.magic_str = Number(o.unit_status.magic_str) + 1800;
						}

						o.unit_status.energy_recovery_rate = Number(o.unit_status.energy_recovery_rate) + 10;
					}
				}

			});
			return leftList = _.orderBy(leftList, 'search_area_width', 'asc');
		},
		rightList: function () {
			var self = this;
			var rank = self.rankOther.toString();
			var wear = self.wearOther;
			var star = self.starOther;
			var growth = Number(this.level) + Number(rank);
			var list = _.cloneDeep(self.nowUnitList);
			var rightList = _.forEach(list, function (o) {
				var ps = _.find(self.$store.getters.getUnitPromotionStatus, { "unit_id": o.unit_id, "promotion_level": rank });
				if (!self.RankBonus) {
					var twStatus = _.find(TwStatus, { "unit_id": o.unit_id, "promotion_level": rank });
					if (twStatus) {
						ps = twStatus;
					}
				}
				var ur = _.find(self.$store.getters.getUnitRarity, { "unit_id": o.unit_id, "rarity": star });
				if (!ur) {
					var ur = _.find(self.$store.getters.getUnitRarity, { "unit_id": o.unit_id, "rarity": "5" });
				}
				var up = _.find(self.$store.getters.getUnitPromotion, { "unit_id": o.unit_id, "promotion_level": rank });
				if (!up || !ur || !ps) {
					return;
				}
				var equipmentList = new Array;
				switch (wear) {
					case "0":
						up = {}
						break;
					case "3":
						up = {
							"equip_slot_2": up.equip_slot_2,
							"equip_slot_4": up.equip_slot_4,
							"equip_slot_6": up.equip_slot_6,
						}
						break;
					case "4":
						up = {
							"equip_slot_2": up.equip_slot_2,
							"equip_slot_4": up.equip_slot_4,
							"equip_slot_5": up.equip_slot_5,
							"equip_slot_6": up.equip_slot_6
						}
						break;
					case "5":
						up = {
							"equip_slot_2": up.equip_slot_2,
							"equip_slot_3": up.equip_slot_3,
							"equip_slot_4": up.equip_slot_4,
							"equip_slot_5": up.equip_slot_5,
							"equip_slot_6": up.equip_slot_6
						}
						break;
					default:
						up = {
							"equip_slot_1": up.equip_slot_1,
							"equip_slot_2": up.equip_slot_2,
							"equip_slot_3": up.equip_slot_3,
							"equip_slot_4": up.equip_slot_4,
							"equip_slot_5": up.equip_slot_5,
							"equip_slot_6": up.equip_slot_6
						}
						break;
				}
				_.forEach(up, function (u) {
					var ed = _.find(self.$store.getters.getEquipmentData, { "equipment_id": u })
					if (!ed) {
						return;
					}
					var cloneEq = _.cloneDeep(ed);
					if (!self.RankBonus) {
						switch (u) {
							case "104102":
								cloneEq.energy_recovery_rate = "12.0";
								break;
							case "104013":
								cloneEq.energy_recovery_rate = "5.0";
								break;
							case "104042":
								cloneEq.energy_recovery_rate = "10.0";
								break;
							case "104132":
								cloneEq.energy_recovery_rate = "5.0";
								break;
							case "104371":
								cloneEq.energy_recovery_rate = "5.0";
								break;
							case "104581":
								cloneEq.hp = "240.0"
								cloneEq.energy_recovery_rate = "0.0";
								cloneEq.hp_recovery_rate = "200.0"
								break;
							case "104611":
								cloneEq.hp = "100.0";
								cloneEq.magic_str = "60.0";
								cloneEq.energy_reduce_rate = "25.0";
								cloneEq.energy_recovery_rate = "0.0";
								break;
						}
					}
					equipmentList.push(cloneEq);

				})

				_.forEach(equipmentList, function (u) {
					o.unit_status.accuracy += Number(u.accuracy) * 2;
					o.unit_status.atk += Number(u.atk) * 2;
					o.unit_status.def += Number(u.def) * 2;
					o.unit_status.dodge += Number(u.dodge) * 2;
					o.unit_status.energy_recovery_rate += Number(u.energy_recovery_rate) * 2;
					o.unit_status.energy_reduce_rate += Number(u.energy_reduce_rate) * 2;
					o.unit_status.hp += Number(u.hp) * 2;
					o.unit_status.hp_recovery_rate += Number(u.hp_recovery_rate) * 2;
					o.unit_status.life_steal += Number(u.life_steal) * 2;
					o.unit_status.magic_critical += Number(u.magic_critical) * 2;
					o.unit_status.magic_def += Number(u.magic_def) * 2;
					o.unit_status.magic_penetrate += Number(u.magic_penetrate) * 2;
					o.unit_status.magic_str += Number(u.magic_str) * 2;
					o.unit_status.physical_critical += Number(u.physical_critical) * 2;
					o.unit_status.physical_penetrate += Number(u.physical_penetrate) * 2;
					o.unit_status.wave_energy_recovery += Number(u.wave_energy_recovery) * 2;
					o.unit_status.wave_hp_recovery += Number(u.wave_hp_recovery) * 2;
				})

				o.unit_status.accuracy = self.ToCeil(o.unit_status.accuracy + Number(ps.accuracy) + Number(ur.accuracy) + (Number(ur.accuracy_growth) * growth));
				o.unit_status.atk = self.ToCeil(o.unit_status.atk + Number(ps.atk) + Number(ur.atk) + (Number(ur.atk_growth) * growth));
				o.unit_status.def = self.ToCeil(o.unit_status.def + Number(ps.def) + Number(ur.def) + (Number(ur.def_growth) * growth));
				o.unit_status.dodge = self.ToCeil(o.unit_status.dodge + Number(ps.dodge) + Number(ur.dodge) + (Number(ur.dodge_growth) * growth));
				o.unit_status.energy_recovery_rate = self.ToCeil(o.unit_status.energy_recovery_rate + Number(ps.energy_recovery_rate) + Number(ur.energy_recovery_rate) + (Number(ur.energy_recovery_rate_growth) * growth));
				o.unit_status.energy_reduce_rate = self.ToCeil(o.unit_status.energy_reduce_rate + Number(ps.energy_reduce_rate) + Number(ur.energy_reduce_rate) + (Number(ur.energy_reduce_rate_growth) * growth));
				o.unit_status.hp = self.ToCeil(o.unit_status.hp + Number(ps.hp) + Number(ur.hp) + (Number(ur.hp_growth) * growth));
				o.unit_status.hp_recovery_rate = self.ToCeil(o.unit_status.hp_recovery_rate + Number(ps.hp_recovery_rate) + Number(ur.hp_recovery_rate) + (Number(ur.hp_recovery_rate_growth) * growth));
				o.unit_status.life_steal = self.ToCeil(o.unit_status.life_steal + Number(ps.life_steal) + Number(ur.life_steal) + (Number(ur.life_steal_growth) * growth));
				o.unit_status.magic_critical = self.ToCeil(o.unit_status.magic_critical + Number(ps.magic_critical) + Number(ur.magic_critical) + (Number(ur.magic_critical_growth) * growth));
				o.unit_status.magic_def = self.ToCeil(o.unit_status.magic_def + Number(ps.magic_def) + Number(ur.magic_def) + (Number(ur.magic_def_growth) * growth));
				o.unit_status.magic_penetrate = self.ToCeil(o.unit_status.magic_penetrate + Number(ps.magic_penetrate) + Number(ur.magic_penetrate) + (Number(ur.magic_penetrate_growth) * growth));
				o.unit_status.magic_str = self.ToCeil(o.unit_status.magic_str + Number(ps.magic_str) + Number(ur.magic_str) + (Number(ur.magic_str_growth) * growth));
				o.unit_status.physical_critical = self.ToCeil(o.unit_status.physical_critical + Number(ps.physical_critical) + Number(ur.physical_critical) + (Number(ur.physical_critical_growth) * growth));
				o.unit_status.physical_penetrate = self.ToCeil(o.unit_status.physical_penetrate + Number(ps.physical_penetrate) + Number(ur.physical_penetrate) + (Number(ur.physical_penetrate_growth) * growth));
				o.unit_status.wave_energy_recovery = self.ToCeil(o.unit_status.wave_energy_recovery + Number(ps.wave_energy_recovery) + Number(ur.wave_energy_recovery) + (Number(ur.wave_energy_recovery_growth) * growth));
				o.unit_status.wave_hp_recovery = self.ToCeil(o.unit_status.wave_hp_recovery + Number(ps.wave_hp_recovery) + Number(ur.wave_hp_recovery) + (Number(ur.wave_hp_recovery_growth) * growth));

				if (self.RankBonus) {
					if (Number(self.rankOther) > 20) {
						if (Number(o.unit_status.atk) > Number(o.unit_status.magic_str)) {
							o.unit_status.atk = Number(o.unit_status.atk) + 1800;
						} else {
							o.unit_status.magic_str = Number(o.unit_status.magic_str) + 1800;
						}

						o.unit_status.energy_recovery_rate = Number(o.unit_status.energy_recovery_rate) + 10;
					}
				}

			});
			return rightList = _.orderBy(rightList, 'search_area_width', 'asc');
		},
		diffList: function () {
			var self = this;
			if (self.diffMode) {
				return self.leftList;
			}
			var left = _.cloneDeep(self.leftList);
			var right = _.cloneDeep(self.rightList);
			var currentList = _.forEach(left, function (obj) {
				var unit = _.find(right, ["unit_id", obj.unit_id]);
				obj.unit_status.accuracy = unit.unit_status.accuracy - obj.unit_status.accuracy;
				obj.unit_status.atk = unit.unit_status.atk - obj.unit_status.atk;
				obj.unit_status.def = unit.unit_status.def - obj.unit_status.def;
				obj.unit_status.dodge = unit.unit_status.dodge - obj.unit_status.dodge;
				obj.unit_status.energy_recovery_rate = unit.unit_status.energy_recovery_rate - obj.unit_status.energy_recovery_rate;
				obj.unit_status.energy_reduce_rate = unit.unit_status.energy_reduce_rate - obj.unit_status.energy_reduce_rate;
				obj.unit_status.hp = unit.unit_status.hp - obj.unit_status.hp;
				obj.unit_status.hp_recovery_rate = unit.unit_status.hp_recovery_rate - obj.unit_status.hp_recovery_rate;
				obj.unit_status.life_steal = unit.unit_status.life_steal - obj.unit_status.life_steal;
				obj.unit_status.magic_critical = unit.unit_status.magic_critical - obj.unit_status.magic_critical;
				obj.unit_status.magic_def = unit.unit_status.magic_def - obj.unit_status.magic_def;
				obj.unit_status.magic_penetrate = unit.unit_status.magic_penetrate - obj.unit_status.magic_penetrate;
				obj.unit_status.magic_str = unit.unit_status.magic_str - obj.unit_status.magic_str;
				obj.unit_status.physical_critical = unit.unit_status.physical_critical - obj.unit_status.physical_critical;
				obj.unit_status.physical_penetrate = unit.unit_status.physical_penetrate - obj.unit_status.physical_penetrate;
				obj.unit_status.wave_energy_recovery = unit.unit_status.wave_energy_recovery - obj.unit_status.wave_energy_recovery;
				obj.unit_status.wave_hp_recovery = unit.unit_status.wave_hp_recovery - obj.unit_status.wave_hp_recovery;
			})
			return currentList;
		},
		locale() {
			return this.$i18n.locale
		}
	},
	methods: {
		getUnitStory: function () {
			var self = this;
			var nowUnitList = new Array;
			if (!self.RankBonus) {
				charaStoryStatus = TwStory;
			};
			var charaStoryStatus = JSON.parse(self.atou(chara_story_status));
			_.forEach(self.$store.getters.getUnitData, function (o) {
				var currentUnit = _.find(self.$store.getters.getCharaIdentity, ["unit_id", o.unit_id]);
				if (_.isEmpty(currentUnit)) {
					return;
				}
				var unit = {
					"search_area_width": "",
					"name": "",
					"unit_id": "",
					"unit_status": {
						"accuracy": 0,
						"atk": 0,
						"def": 0,
						"dodge": 0,
						"energy_recovery_rate": 0,
						"energy_reduce_rate": 0,
						"hp": 0,
						"hp_recovery_rate": 0,
						"life_steal": 0,
						"magic_critical": 0,
						"magic_def": 0,
						"magic_penetrate": 0,
						"magic_str": 0,
						"physical_critical": 0,
						"physical_penetrate": 0,
						"wave_energy_recovery": 0,
						"wave_hp_recovery": 0,
					}
				};
				var chara_id = o.unit_id.slice(0, -2);
				var storyUp = _.filter(charaStoryStatus, function (chara) {
					return chara.chara_id_1 == chara_id || chara.chara_id_2 == chara_id || chara.chara_id_3 == chara_id || chara.chara_id_4 == chara_id || chara.chara_id_5 == chara_id || chara.chara_id_6 == chara_id || chara.chara_id_7 == chara_id || chara.chara_id_8 == chara_id || chara.chara_id_9 == chara_id || chara.chara_id_10 == chara_id;
				});
				if (storyUp.length < 3) {
					return;
				}
				_.forEach(storyUp, function (su) {
					for (var i = 1; i <= 5; i++) {
						if (su['status_rate_' + (i)] != "0") {
							switch (su['status_type_' + (i)]) {
								case "1":
									unit.unit_status.hp += Number(su['status_rate_' + (i)]);
									break;
								case "2":
									unit.unit_status.atk += Number(su['status_rate_' + (i)]);
									break;
								case "3":
									unit.unit_status.def += Number(su['status_rate_' + (i)]);
									break;
								case "4":
									unit.unit_status.magic_str += Number(su['status_rate_' + (i)]);
									break;
								case "5":
									unit.unit_status.magic_def += Number(su['status_rate_' + (i)]);
									break;
								case "6":
									unit.unit_status.physical_critical += Number(su['status_rate_' + (i)]);
									break;
								case "7":
									unit.unit_status.magic_critical += Number(su['status_rate_' + (i)]);
									break;
								case "8":
									unit.unit_status.dodge += Number(su['status_rate_' + (i)]);
									break;
								case "9":
									unit.unit_status.life_steal += Number(su['status_rate_' + (i)]);
									break;
								case "10":
									unit.unit_status.wave_hp_recovery += Number(su['status_rate_' + (i)]);
									break;
								case "11":
									unit.unit_status.wave_energy_recovery += Number(su['status_rate_' + (i)]);
									break;
								case "15":
									unit.unit_status.hp_recovery_rate += Number(su['status_rate_' + (i)]);
									break;
								case "17":
									unit.unit_status.accuracy += Number(su['status_rate_' + (i)]);
									break;
								default:
									break;
							}
						}
					}
				});
				unit.search_area_width = o.search_area_width;
				unit.name = o.kana;
				unit.jp_name = o.jp_unit_name;
				unit.en_name = o.en_unit_name;
				unit.unit_id = o.unit_id;
				nowUnitList.push(unit);
			});
			self.nowUnitList = _.orderBy(nowUnitList, ['search_area_width', 'unit_id'], ['asc', 'asc']);
		},
		isGreaterOrLowerZeroClass: function (str) {
			var number = Number(str);
			if (number > 0) {
				return "big";
			} else if (number < 0) {
				return "small";
			}
			return "";
		},
		ToCeil: function (status) {
			var number = Number(status);
			return Math.round(number);
		},
		changeMode: function () {
			this.diffMode = !this.diffMode;
			var table = $('#diffTable').DataTable();
			table.destroy();
			this.$nextTick(function () {
				if (this.clientWidth > 1000) {
					$('#diffTable').dataTable({
						scrollY: "800px",
						scrollX: true,
						scrollCollapse: true,
						paging: false
					});
				} else {
					$('#diffTable').dataTable({
						scrollY: "800px",
						scrollX: true,
						scrollCollapse: true,
						paging: false
					});
				}
			})

		},
		fullScreen: function () {
			this.fullScreenMode = !this.fullScreenMode;
			var table = $('#diffTable').DataTable();
			table.destroy();

			if (this.fullScreenMode) {
				$("#table-wrap").addClass("fullScreen");
			} else {
				$("#table-wrap").removeClass("fullScreen");
			}

			if (this.clientWidth > 1000) {
				$('#diffTable').dataTable({
					scrollY: "800px",
					scrollX: true,
					scrollCollapse: true,
					paging: false
				});
			} else {
				$('#diffTable').dataTable({
					scrollY: "800px",
					scrollX: true,
					scrollCollapse: true,
					paging: false
				});
			}
		},
		replaceName: function (item) {
			try {
				const name = this.getI18nName(item, 'name')
				if (name) {
					return name.replace("（", "<br />（")
				} else {
					return 'not set yet'
				}
			} catch (e) {
				console.log(e)
				return 'not set yet'
			}
		},
		activeRankBonus: function () {
			this.RankBonus = !this.RankBonus;
			this.getUnitStory();
		},
		getI18nName: function (item, name) {
			switch (this.locale) {
				case "en":
					return item["en_" + name]
					break
				case "jp":
					return item["jp_" + name]
					break
				default:
					return item[name]
					break
			}
		}
	},
	mounted: function () {
		if (this.clientWidth > 1000) {
			$('#diffTable').dataTable({
				scrollY: "800px",
				scrollX: true,
				scrollCollapse: true,
				paging: false
			});
		} else {
			$('#diffTable').dataTable({
				scrollY: "800px",
				scrollX: true,
				scrollCollapse: true,
				paging: false
			});
		}
	}
}

</script>
<style type="text/css">
#diffTable_wrapper tbody th,
#diffTable_wrapper tbody td {
	padding: .75rem;
	vertical-align: middle;
}

#diffTable_wrapper th {
	background-color: #efefef;
	min-width: 80px;
	border-bottom: 1px solid #CDA64B;
}

#diffTable_wrapper td {
	background-color: #fff;
}

#diffTable_wrapper .no-footer {
	border: none;
}

.fullScreen {
	display: block;
	z-index: 9999;
	position: fixed;
	width: 100%;
	height: 100vh;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	overflow: auto;
	padding: 10px;
	background: url("/static/images/itembg.png");
	border-radius: 30px;
	-moz-border-radius: 30px;
	-webkit-border-radius: 30px;
	border: 3px solid #f5d68e;
	-webkit-box-shadow: 0 5px 5px 0 #948d6e;
	box-shadow: 0 5px 5px 0 #948d6e;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	color: #181818;
}

.dark .fullScreen #diffTable_wrapper {
	color: #cdc1c1;
}
</style>